// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placement-gizmo {
  position: fixed;
  left: 0;
  top: 0;
  pointer-events: none;
  z-index: 39;
}
.placement-gizmo__marker {
  pointer-events: none;
}
.placement-gizmo__marker-ring {
  fill: rgba(255, 210, 74, 0.08);
  stroke: #ffd24a;
  stroke-width: 2;
  animation: placement-gizmo-pulse 1.4s ease-in-out infinite;
  transform-box: fill-box;
  transform-origin: center;
}
.placement-gizmo__marker-dot {
  fill: #ffd24a;
}
.placement-gizmo__marker-ticks {
  stroke: #ffd24a;
  stroke-width: 2;
  stroke-linecap: round;
  fill: none;
}
.placement-gizmo__grab {
  fill: transparent;
  pointer-events: all;
  cursor: grab;
}
.placement-gizmo__marker.is-grabbed .placement-gizmo__marker-ring {
  animation: none;
  fill: rgba(255, 210, 74, 0.22);
}
.placement-gizmo__marker.is-grabbed .placement-gizmo__grab {
  cursor: grabbing;
}

@keyframes placement-gizmo-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.25);
    opacity: 0.6;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/placementGizmo/styles.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,oBAAA;EACA,WAAA;AAAF;AAEE;EACE,oBAAA;AAAJ;AAGE;EACE,8BAAA;EACA,eAAA;EACA,eAAA;EACA,0DAAA;EACA,uBAAA;EACA,wBAAA;AADJ;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,eAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;AAHJ;AAME;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;AAJJ;AAQI;EACE,eAAA;EACA,8BAAA;AANN;AASI;EACE,gBAAA;AAPN;;AAYA;EACE;IAAW,mBAAA;IAAqB,UAAA;EAPhC;EAQA;IAAM,sBAAA;IAAwB,YAAA;EAJ9B;AACF","sourcesContent":["// Marker that follows the piece being placed; it is grabbed with the mouse once the browser has the focus.\n.placement-gizmo {\n  position: fixed;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  z-index: 39;\n\n  &__marker {\n    pointer-events: none;\n  }\n\n  &__marker-ring {\n    fill: rgba(255, 210, 74, 0.08);\n    stroke: #ffd24a;\n    stroke-width: 2;\n    animation: placement-gizmo-pulse 1.4s ease-in-out infinite;\n    transform-box: fill-box;\n    transform-origin: center;\n  }\n\n  &__marker-dot {\n    fill: #ffd24a;\n  }\n\n  &__marker-ticks {\n    stroke: #ffd24a;\n    stroke-width: 2;\n    stroke-linecap: round;\n    fill: none;\n  }\n\n  &__grab {\n    fill: transparent;\n    pointer-events: all;\n    cursor: grab;\n  }\n\n  &__marker.is-grabbed {\n    .placement-gizmo__marker-ring {\n      animation: none;\n      fill: rgba(255, 210, 74, 0.22);\n    }\n\n    .placement-gizmo__grab {\n      cursor: grabbing;\n    }\n  }\n}\n\n@keyframes placement-gizmo-pulse {\n  0%, 100% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.25); opacity: 0.6; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
